//Name: Female Shoe Sizes
//Code: SHOW
//Age: Adult
//Gender: Female
const femaleShoeSizes = [
  { id: '170', values: [
    {region: "AU", name: "1"},
    {region: "NZ", name: "1"},
    {region: "US", name: "2.5"},
    {region: "UK", name: "0"},
    {region: "EU", name: "32.5"}
  ]},
  { id: '171', values: [
    {region: "AU", name: "1.5"},
    {region: "NZ", name: "1.5"},
    {region: "US", name: "3"},
    {region: "UK", name: "0.5"},
    {region: "EU", name: "33"}
  ]},
  { id: '172', values: [
    {region: "AU", name: "2"},
    {region: "NZ", name: "2"},
    {region: "US", name: "3.5"},
    {region: "UK", name: "1"},
    {region: "EU", name: "33.5"}
  ]},
  { id: '173', values: [
    {region: "AU", name: "2.5"},
    {region: "NZ", name: "2.5"},
    {region: "US", name: "4"},
    {region: "UK", name: "1.5"},
    {region: "EU", name: "34"}
  ]},
  { id: '49', values: [
    {region: "AU", name: "3"},
    {region: "NZ", name: "3"},
    {region: "US", name: "4.5"},
    {region: "UK", name: "2"},
    {region: "EU", name: "34.5"}
  ]},
  { id: '50', values: [
    {region: "AU", name: "3.5"},
    {region: "NZ", name: "3.5"},
    {region: "US", name: "5"},
    {region: "UK", name: "2.5"},
    {region: "EU", name: "35"}
  ]},
  { id: '51', values: [
    {region: "AU", name: "4"},
    {region: "NZ", name: "4"},
    {region: "US", name: "5.5"},
    {region: "UK", name: "3"},
    {region: "EU", name: "35.5"}
  ]},
  { id: '52', values: [
    {region: "AU", name: "4.5"},
    {region: "NZ", name: "4.5"},
    {region: "US", name: "6"},
    {region: "UK", name: "3.5"},
    {region: "EU", name: "36"}
  ]},
  { id: '53', values: [
    {region: "AU", name: "5"},
    {region: "NZ", name: "5"},
    {region: "US", name: "6.5"},
    {region: "UK", name: "4"},
    {region: "EU", name: "37"}
  ]},
  { id: '54', values: [
    {region: "AU", name: "5.5"},
    {region: "NZ", name: "5.5"},
    {region: "US", name: "7"},
    {region: "UK", name: "4.5"},
    {region: "EU", name: "37.5"}
  ]},
  { id: '55', values: [
    {region: "AU", name: "6"},
    {region: "NZ", name: "6"},
    {region: "US", name: "7.5"},
    {region: "UK", name: "5"},
    {region: "EU", name: "38"}
  ]},
  { id: '56', values: [
    {region: "AU", name: "6.5"},
    {region: "NZ", name: "6.5"},
    {region: "US", name: "8"},
    {region: "UK", name: "5.5"},
    {region: "EU", name: "38.5"}
  ]},
  { id: '57', values: [
    {region: "AU", name: "7"},
    {region: "NZ", name: "7"},
    {region: "US", name: "8.5"},
    {region: "UK", name: "6"},
    {region: "EU", name: "39"}
  ]},
  { id: '58', values: [
    {region: "AU", name: "7.5"},
    {region: "NZ", name: "7.5"},
    {region: "US", name: "9"},
    {region: "UK", name: "6.5"},
    {region: "EU", name: "40"}
  ]},
  { id: '59', values: [
    {region: "AU", name: "8"},
    {region: "NZ", name: "8"},
    {region: "US", name: "9.5"},
    {region: "UK", name: "7"},
    {region: "EU", name: "41"}
  ]},
  { id: '60', values: [
    {region: "AU", name: "8.5"},
    {region: "NZ", name: "8.5"},
    {region: "US", name: "10"},
    {region: "UK", name: "7.5"},
    {region: "EU", name: "42"}
  ]},
  { id: '156', values: [
    {region: "AU", name: "9"},
    {region: "NZ", name: "9"},
    {region: "US", name: "10.5"},
    {region: "UK", name: "8"},
    {region: "EU", name: "43"}
  ]},
  { id: '61', values: [
    {region: "AU", name: "9.5"},
    {region: "NZ", name: "9.5"},
    {region: "US", name: "11"},
    {region: "UK", name: "8.5"},
    {region: "EU", name: "44"}
  ]},
  { id: '157', values: [
    {region: "AU", name: "10"},
    {region: "NZ", name: "10"},
    {region: "US", name: "11.5"},
    {region: "UK", name: "9"},
    {region: "EU", name: "45"}
  ]},
  { id: '62', values: [
    {region: "AU", name: "10.5"},
    {region: "NZ", name: "10.5"},
    {region: "US", name: "12"},
    {region: "UK", name: "9.5"},
    {region: "EU", name: "46.5"}
  ]},
  { id: '158', values: [
    {region: "AU", name: "11"},
    {region: "NZ", name: "11"},
    {region: "US", name: "12.5"},
    {region: "UK", name: "10"},
    {region: "EU", name: "48.5"}
  ]},
  { id: '63', values: [
    {region: "AU", name: "11.5"},
    {region: "NZ", name: "11.5"},
    {region: "US", name: "13"},
    {region: "UK", name: "10.5"},
    {region: "EU", name: "49"}
  ]},
  { id: '159', values: [
    {region: "AU", name: "12"},
    {region: "NZ", name: "12"},
    {region: "US", name: "13.5"},
    {region: "UK", name: "11"},
    {region: "EU", name: "46.5"}
  ]},
  { id: '64', values: [
    {region: "AU", name: "12.5"},
    {region: "NZ", name: "12.5"},
    {region: "US", name: "14"},
    {region: "UK", name: "11.5"},
    {region: "EU", name: "47"}
  ]},
  { id: '160', values: [
    {region: "AU", name: "13"},
    {region: "NZ", name: "13"},
    {region: "US", name: "14.5"},
    {region: "UK", name: "12"},
    {region: "EU", name: "47.5"}
  ]},
  { id: '161', values: [
    {region: "AU", name: "13.5"},
    {region: "NZ", name: "13.5"},
    {region: "US", name: "15"},
    {region: "UK", name: "12.5"},
    {region: "EU", name: "48"}
  ]},
  { id: '65', values: [
    {region: "AU", name: "14"},
    {region: "NZ", name: "14"},
    {region: "US", name: "15.5"},
    {region: "UK", name: "13"},
    {region: "EU", name: "48.5"}
  ]}
];

export default femaleShoeSizes;



// WEBPACK FOOTER //
// ./src/data/female-shoe-sizes.js